module.exports = "/_next/static/images/TankerL-383cb378bafdf9554d38b4accaa367a3.svg";